'use strict'

export function easeInOutQuad(t, b, c, d) {
  t /= d / 2
  if (t < 1) {
    return c / 2 * t * t + b
  }
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

export function easeScrollTo(to) {
  const body = document.querySelector('body')
  const from = body.scrollTop
  const duration = 1200
  const increment = 1000 / 60
  let currentTime = 0

  const animateScroll = () => {
    currentTime += increment
    const val = easeInOutQuad(currentTime, from, to, duration)
    window.scrollTo(0, val)
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll)
    }
  }

  animateScroll()
}
